import React, { useEffect, useState } from "react";
import WalletItem from "./WalletItem";
import { editIcon } from "../../../Base/SVG";
import { motion } from "framer-motion";

export default function Wallets() {
  const [isLoading, setIsLoading] = useState(true);
  const [form, setForm] = useState({
    wallets: [
      {
        id: "1",
        address: "0x0324d...a1ea3",
        network: "Smart Chain",
        networkIcon: "/images/networks/binance.svg",
        status: true,
        coins: [
          {
            id: "1",
            coin: "BUSD",
            coinIcon: "/images/networks/binance.svg",
            status: true,
          },
          {
            id: "2",
            coin: "USDT",
            coinIcon: "/images/tokens/tether.svg",
            status: false,
          },
          {
            id: "3",
            coin: "USDC",
            coinIcon: "/images/tokens/USDC.svg",
            status: false,
          },
          {
            id: "4",
            coin: "DAI",
            coinIcon: "/images/tokens/DAI.svg",
            status: false,
          },
        ],
      },
      {
        id: "2",
        address: "0x0324d...a1ea3",
        network: "Ethereum",
        networkIcon: "/images/networks/eth.svg",
        status: true,
        coins: [
          {
            id: "1",
            coin: "BUSD",
            coinIcon: "/images/networks/binance.svg",
            status: true,
          },
          {
            id: "1",
            coin: "USDT",
            coinIcon: "/images/tokens/tether.svg",
            status: false,
          },
          {
            id: "3",
            coin: "USDC",
            coinIcon: "/images/tokens/USDC.svg",
            status: true,
          },
          {
            id: "4",
            coin: "DAI",
            coinIcon: "/images/tokens/DAI.svg",
            status: false,
          },
        ],
      },
      {
        id: "3",
        address: "0x0324d...a1ea3",
        network: "Avalanche",
        networkIcon: "/images/networks/avalanche.svg",
        status: true,
        coins: [
          {
            id: "1",
            coin: "BUSD",
            coinIcon: "/images/networks/binance.svg",
            status: true,
          },
          {
            id: "1",
            coin: "USDT",
            coinIcon: "/images/tokens/tether.svg",
            status: false,
          },
          {
            id: "3",
            coin: "USDC",
            coinIcon: "/images/tokens/USDC.svg",
            status: false,
          },
          {
            id: "4",
            coin: "DAI",
            coinIcon: "/images/tokens/DAI.svg",
            status: false,
          },
        ],
      },
      {
        id: "3",
        address: "0x0324d...a1ea3",
        network: "Smart Chain",
        networkIcon: "/images/networks/binance.svg",
        status: false,
        coins: [
          {
            id: "1",
            coin: "BUSD",
            coinIcon: "/images/networks/binance.svg",
            status: true,
          },
          {
            id: "1",
            coin: "USDT",
            coinIcon: "/images/tokens/tether.svg",
            status: false,
          },
          {
            id: "3",
            coin: "USDC",
            coinIcon: "/images/tokens/USDC.svg",
            status: false,
          },
          {
            id: "4",
            coin: "DAI",
            coinIcon: "/images/tokens/DAI.svg",
            status: false,
          },
        ],
      },
    ],
  });
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };

  const lazyDummy = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };
  useEffect(() => {
    lazyDummy();
  }, []);
  return (
    <>
      <div className="wallets">
        <div className="auto__container">
          {isLoading ? (
            <>
              <h3 className="placeholder"></h3>
              <div className="wallets__inner box">
                <div className="invoiceTable__body">
                  <div className="placeholder"></div>
                  {[0, 1, 2, 3].map((item, index) => {
                    return <div className="placeholder" key={index}></div>;
                  })}
                </div>
              </div>
              <h3 className="placeholder"></h3>
              <div className="wallets__inner box">
                <div className="invoiceTable__body">
                  <div className="placeholder"></div>
                  {[0, 1, 2, 3].map((item, index) => {
                    return <div className="placeholder" key={index}></div>;
                  })}
                </div>
              </div>
            </>
          ) : (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
              exit={{ opacity: 0, y: 10 }}
            >
              <h3>Wallets</h3>
              <div className="wallets__inner box">
                {form.wallets.map((item, index) => {
                  return (
                    <WalletItem
                      form={form}
                      updateForm={updateForm}
                      itemData={item}
                      key={index}
                      index={index}
                    />
                  );
                })}
                <div className="wallets__inner-footer">
                  <button type="button" className="button bordered">
                    Reset All
                  </button>
                  <button type="button" className="button primary">
                    Save
                  </button>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      </div>
      <div className="start">
        <div className="auto__container">
          <h3>How to start?</h3>
          <div className="start__inner box">
            <div className="startItem">
              <div className="startItem__number">
                <span>01</span>
              </div>
              <p className="lg">Paste your wallet address</p>
              <div className="input">
                <input type="text" defaultValue="0x0324d...a1ea3" />
                <button className="button" type="button">
                  {editIcon}
                </button>
              </div>
            </div>
            <div className="start__arrow">
              <img
                src={process.env.PUBLIC_URL + "/images/arrow.png"}
                alt="arrow"
              />
            </div>
            <div className="startItem">
              <div className="startItem__number">
                <span>02</span>
              </div>
              <p className="lg">Activate network</p>
              <div className="check">
                <div className="check__row">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/networks/binance.svg"
                    }
                    alt="networks"
                  />
                  <p>Smart Chain</p>
                </div>
                <div className="checkInput">
                  <input type="checkbox" checked={true} />
                  <label htmlFor=""></label>
                </div>
              </div>
            </div>
            <div className="start__arrow">
              <img
                src={process.env.PUBLIC_URL + "/images/arrow.png"}
                alt="arrow"
              />
            </div>
            <div className="startItem">
              <div className="startItem__number">
                <span>03</span>
              </div>
              <p className="lg">Turn on tokens</p>
              <div className="check">
                <div className="check__row">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/networks/binance.svg"
                    }
                    alt="coin"
                  />
                  <p>BUSD</p>
                </div>
                <div className="checkInput">
                  <input type="checkbox" checked={true} />
                  <label htmlFor=""></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
